import { mapActions, mapState } from 'vuex';
import shareMixin from '@/lib/ui/mixins/shareMixin';
import searchMixin from '@/components/search/mixins/searchMixin';
import externalUrlMixin from '@/components/content/mixins/externalUrlMixin';

export default {
  mixins: [
    shareMixin,
    searchMixin,
    externalUrlMixin,
  ],
  data: () => ({
    previewContent: null,
    openModal: false,
    openInsightsModal: false,
  }),
  computed: {
    ...mapState('discovery', [
      'documentInteraction',
    ]),
    openPreview: {
      get() {
        return this.openModal;
      },
      set(value) {
        this.openModal = value;
        if (!value) {
          this.previewContent = null;
        }
      },
    },
    showInsight: {
      get() {
        return this.openInsightsModal;
      },
      set(value) {
        this.openInsightsModal = value;
      },
    },
  },
  methods: {
    ...mapActions('discovery', [
      'getDocument',
      'download',
      'openPreviewModalWindow',
      'openContentInsightModalWindow',
      'setAssetDashbordDetails',
      'markAsViewed',
    ]),
    ...mapActions('uploader', [
      'openEditMetadata',
      'openAddToCollection',
      'openUploader',
    ]),
    /**
     *
     * @param document {InsightContent|DiscoveryContent|Asset}
     */
    showDocument(content) {
      console.log('Asset mixins, showing preview');
      console.log(content);
      this.openPreviewModalWindow(content);
    },
    onModalClosed() {
      this.openPreview = false;
    },
    /**
     *
     * @param document {InsightContent|DiscoveryContent|Asset}
     */
    async showInsightsModal(content) {
      await this.openContentInsightModalWindow({
        document: content,
      });

      if (content.asset) {
        content.asset.interactionInsight = this.documentInteraction;
      }
    },
    closeInsight() {
      this.showInsight = false;
    },
    editMetadata(content) {
      // console.log('Edit Metadata', content);

      const docId = content?.id;
      this.openEditMetadata(docId);
    },
    addToCollection(content) {
      const docId = content?.docId;
      this.openAddToCollection(docId);
    },
    async gotoAssetDashboard(content) {
      await this.getDocument(content.docId);

      console.log('DF', content.dashboardFilters);
      // set state of the external url fields in actions
      this.setAssetDashbordDetails({
        externalUrl: content.externalUrl,
        externalUrlAction: content.externalUrlAction,
        externalUrlLabel: content.externalUrlLabel,
        dashboardFilters: content.dashboardFilters,
        dashboardBookmarks: content.dashboardBookmarks,
      });

      if (this.isNewWindowAction()) {
        const externalUrl = this.assetExternalUrl();
        this.openLinkInNewTab(externalUrl);
      } else {
        // if rd is not empty, we're here because somebody clicked on the refresh button on global nav
        const { rd } = this.$route.query;
        if (!rd) {
          this.$router.push(this.assetEmbedRoute(content.docId));
        }
      }

      await this.markAsViewed(content.docId);
    },
    openLinkInNewTab(externalUrl) {
      if (!externalUrl) {
        console.error('invalid externalUrl');
        return;
      }

      const link = document.createElement('a');
      link.href = externalUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
